/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

import { message, ConfigProvider } from "antd"

// Import all the third party stuff
import React from "react"
import ReactDOM from "react-dom"
import { Provider } from "react-redux"
import { ConnectedRouter } from "connected-react-router/immutable"
import history from "utils/history"
import { LOCAL_USER_ID } from "utils/storage"
// import 'react-select/dist/react-select.css'
import "sanitize.css/sanitize.css"
import "./index.less"
// Import root app
import App from "containers/App"

// Import Language Provider
import LanguageProvider from "containers/LanguageProvider"

import esES from "antd/lib/locale-provider/es_ES"
import enUS from "antd/lib/locale-provider/en_US"
import Pusher from "pusher-js"
import configureStore from "./configureStore"

// Import i18n messages
import { translationMessages } from "./i18n"

import ReactGA from "react-ga"
import TagManager from "react-gtm-module"
import {
  startWoopra,
  woopraTrackPageView,
} from "./utils/woopra/woopraTracker"
import { verifyFeatureFlag } from "./utils/feature-flags"
import { LOCAL_FIRST_NAME, LOCAL_LAST_NAME, LOCAL_USER_EMAIL } from "./utils/storage"
import { isNotFromIframe } from "./utils/functions"
import { SUPPORT_CHANNELS } from "./utils/constants"
import { hasAnalyticsConsent, onAnalyticsConsent } from "./utils/cookieyes"
/* webscoket */
window.message = message

// Create redux store with history
const initialState = {}
const store = configureStore(initialState, history)
const MOUNT_NODE = document.getElementById("app")

const pusher = new Pusher("2ca2b00e7414fe8f2cbf", {
  cluster: "mt1",
  forceTLS: true,
})

// const trackingId = "UA-151301947-2" // Replace with your Google Analytics tracking ID
// ReactGA.initialize(trackingId)

// Tag Manager code
const tagManagerArgs = {
  gtmId: "GTM-KGCZ8ZL",
}

// VLENG-11641: GTM-KGCZ8ZL no dependía del consentimiento de CookieYes (a
// diferencia de los scripts inline gateados en index.html vía data-cookieyes),
// por lo que disparaba beacons de GA sin consentimiento. Se difiere su init
// hasta que haya consentimiento de analítica (RN7 — fail-open sin trackear).
onAnalyticsConsent(() => {
  TagManager.initialize(tagManagerArgs)
})

const unTrackedPaths = ["/login", "/forgottenPassword"]

history.listen((location) => {
  // ReactGA.set({ page: location.pathname }) // Update the user's current page
  // ReactGA.pageview(location.pathname) // Record a pageview for the given page
  const dataLayerData = {
    dataLayer: {
      userId: LOCAL_USER_ID(),
      event: "atm.event",
      path: location.pathname.substring(1),
    },
  }
  if (!unTrackedPaths.includes(history.location.pathname)) {
    woopraTrackPageView() // Record pv for woopra
    if (hasAnalyticsConsent()) {
      TagManager.dataLayer(dataLayerData) // Record pv for GTM
    }
  }
})

window.initializeChatWidget = function(user) {

  const app_id = user.app_id || SUPPORT_CHANNELS.DEFAULT

  window.intercomSettings = {
    api_base: "https://api-iam.eu.intercom.io",
    app_id: app_id,
    user_id: user.id,          
    name: user.name,           
    email: user.email,         
    created_at: Math.floor(new Date(user.createdAt).getTime() / 1000) 
  };

  (function() {
    var w = window;
    var ic = w.Intercom;
    if (typeof ic === "function") {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    } else {
      var d = document;
      var i = function() { i.c(arguments); };
      i.q = [];
      i.c = function(args) { i.q.push(args); };
      w.Intercom = i;

      function l() {
        var s = d.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = `https://widget.intercom.io/widget/${app_id}`; 
        var x = d.getElementsByTagName("script")[0];
        x.parentNode.insertBefore(s, x);
      }

      if (document.readyState === "complete") {
        l();
      } else if (w.attachEvent) {
        w.attachEvent("onload", l);
      } else {
        w.addEventListener("load", l, false);
      }
    }
  })();
};


if(!window.fcWidget) {
  if(isNotFromIframe()) {
    /*
    initializeChatWidget({
      id: LOCAL_USER_ID(),
      name: `${LOCAL_FIRST_NAME()} ${LOCAL_LAST_NAME()}`,
      email: LOCAL_USER_EMAIL(),
      createdAt: Date.now()
    });
    */
  }
}




// startWoopra()

const render = (messages) => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages}>
        <ConnectedRouter history={history}>
          <ConfigProvider
            locale={localStorage.getItem("language") == "es" ? esES : enUS}>
            <App />
          </ConfigProvider>
        </ConnectedRouter>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE
  )
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import("intl"))
  })
    .then(() => Promise.all([import("intl/locale-data/jsonp/en.js")]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err
    })
} else {
  render(translationMessages)
}


// [Wootric disabled]
// let _LOCAL_USER_EMAIL = localStorage.getItem("USER_EMAIL") || null
// let _VERIFY_URL =
//     window.location.pathname.includes("/companies") &&
//     window.location.pathname.includes("/users")
//     // console.log('hollaaaaaa',_VERIFY_URL)
// if (_LOCAL_USER_EMAIL && !_VERIFY_URL && typeof window.wootric === 'function') {
//     let _COMPANY_NAME = localStorage.getItem("COMPANY_NAME") || null
//     let _ACTIVE_ROL_NAME = localStorage.getItem("ACTIVE_ROL_NAME") || null
//     let _COMPANY_HUBSPOT = localStorage.getItem("COMPANY_HUBSPOT") || null
//
//     //get if the url path are /companies and /users  set a variable to false
//
//     if(_COMPANY_NAME && _ACTIVE_ROL_NAME) {
//       //window.wootric_survey_immediately = true // Shows survey immediately for testing purposes. TODO: Comment out for production.
//       window.wootricSettings = {
//         email: _LOCAL_USER_EMAIL, // TODO: Required to uniquely identify a user. Email is recommended but this can be any unique identifier.
//         // external_id: 'abc123', // TODO: Reference field for external integrations only. Send it along with email. OPTIONAL
//         // TODO: sign-up date as a 10 digit Unix timestamp in seconds. OPTIONAL
//         //created_at: Math.round(new Date().getTime() / 1000),
//         account_token: "NPS-EU-6170a823", // This is your unique account token.
//         properties: {
//           stage: process.env.STAGE,
//           company: _COMPANY_NAME,
//           role: _ACTIVE_ROL_NAME,
//           hubspot:_COMPANY_HUBSPOT
//         },
//       }
//
//       const isEmbedded = window.top !== window.self;
//
//       if (!isEmbedded) {
//         if (verifyFeatureFlag("wootric")) {
//           window.wootric("run")
//         }
//         window.wootric.alreadyRunning = true
//       }
//
//     }
// }

